import { CustomerApi } from 'api'

export const identifyByHubspotUtk = async (hubspotUtk: Record<string, any>) => CustomerApi.post(`/integrations/hubspot/utk`, hubspotUtk)
